import React from "react";

const TicketTableHeader = ({ onSort, sortConfig }) => {
  const headers = [
    { label: "Ticket", key: "ticket", sortable: true },
    { label: "Title", key: "title", sortable: true },
    { label: "Subject", key: "subject", sortable: false },
    { label: "Status", key: "status", sortable: true },
    { label: "Doc Class Type", key: "assignee", sortable: true },
    { label: "LOB", key: "lob", sortable: true },
    { label: "Created", key: "created", sortable: true },
    { label: "CheckNumber", key: "checkNumber", sortable: false },
    { label: "CheckType", key: "CheckType", sortable: true },
    { label: "CheckAmount", key: "checkAmount", sortable: false },
    { label: "Comments", key: null, sortable: false },
    { label: "View", key: null, sortable: false },
    { label: "Action", key: null, sortable: false },
  ];

  return (
    <thead>
      <tr>
        {headers.map((header, index) => (
          <th
            key={index}
            className={`cursor-pointer border-b-5 p-2 transition-colors ${
              header.sortable ? "hover:bg-blue-gray-50" : ""
            }`}
            onClick={() => header.sortable && header.key && onSort(header.key)}
          >
            <p className="font-20-30-400 flex items-center gap-10 cursor-pointer">
              {header.label}
              {header.sortable && header.key && sortConfig.key === header.key && (
                sortConfig.direction === "asc" ? <span>▲</span> : <span>▼</span>
              )}
              {header.sortable && header.key && sortConfig.key !== header.key && (
                <span>↕</span>
              )}
            </p>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TicketTableHeader;
